import React from 'react';
import { Grid, Paper, Button } from '@mui/material';
import AdminPreOrderReview from './admin_preOrderReview';

const Admin = ({ onGoBack, usernameEmail }) => {
  // Sample list of items (replace with your actual data)
  const items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'];

  return (
    <>
      <AdminPreOrderReview usernameEmail={usernameEmail} />
    </>
    // <Grid container spacing={3}>
    //   <Grid item xs={3}>
    //     <Paper elevation={3} style={{ padding: '16px' }}>
    //       <h2>Item List</h2>
    //       <ul>
    //         {items.map((item, index) => (
    //           <li key={index}>{item}</li>
    //         ))}
    //       </ul>
    //     </Paper>
    //   </Grid>
    //   <Grid item xs={9}>
    //     {/* Add content for the right 9 columns here */}
        
    //   </Grid>
    //   <Grid item xs={12}>
    //     <Button variant="contained" onClick={onGoBack}>
    //       Go Back to Dashboard
    //     </Button>
    //   </Grid>
    // </Grid>
  );
};

export default Admin;
